import React from 'react';

const ResourceTable = ({ resources, selectedNodes, setSelectedNodes }) => {
  const handleNodeChange = (imageName, value) => {
    setSelectedNodes(prev => ({
      ...prev,
      [imageName]: {
        ...prev[imageName],
        count: parseInt(value, 10) || 0,
      }
    }));
  };

  const handleCheckboxChange = (imageName, vcpu, memory, nodesCount, checked) => {
    setSelectedNodes(prev => {
      const newSelectedNodes = { ...prev };
      if (checked) {
        newSelectedNodes[imageName] = { 
          vcpu: parseFloat(vcpu), 
          memory: parseFloat(memory), 
          count: parseInt(nodesCount, 10) || 1 
        };
      } else {
        delete newSelectedNodes[imageName];
      }
      return newSelectedNodes;
    });
  };

  return (
    <table className="cml-table">
      <thead>
        <tr>
          <th></th>
          <th>Image</th>
          <th>vCPU</th>
          <th>Memory (GB)</th>
          <th>Number of Nodes</th>
        </tr>
      </thead>
      <tbody>
        {resources.map(resource => (
          <tr key={resource._ID}>
            <td>
              <input
                type="checkbox"
                onChange={(e) => handleCheckboxChange(
                  resource.image_name, 
                  resource.vcpu, 
                  resource.memory_gb, 
                  resource.nodes_count, 
                  e.target.checked
                )}
              />
            </td>
            <td>{resource.image_name}</td>
            <td>{resource.vcpu}</td>
            <td>{resource.memory_gb}</td>
            <td>
              <input
                type="number"
                min="1"
                defaultValue={resource.nodes_count}
                onChange={(e) => handleNodeChange(resource.image_name, e.target.value)}
                disabled={!selectedNodes[resource.image_name]}
                style={{ width: '60px' }}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ResourceTable;